import { atom } from 'jotai';
import { getLocalStorageItem, setLocalStorageItem } from '@utils/storage';

const createAtom = <T>(storageKey: string, initialValue: T, stringify: boolean = false) => {
    const baseAtom = atom(initialValue);
    return atom(
        (get) => get(baseAtom),
        (get, set, update) => {
            const nextValue = typeof update === 'function' ? update(get(baseAtom)) : update;
            set(baseAtom, nextValue);
            if (stringify) {
                setLocalStorageItem(storageKey, JSON.stringify(nextValue));
                return;
            }
            setLocalStorageItem(storageKey, nextValue);
        },
    );
};

export const stringAtomWithLocalStorage = (storageKey: string, initialValue: string) => {
    const getInitialValue = (): string => {
        return getLocalStorageItem(storageKey) || initialValue;
    };
    return createAtom<string>(storageKey, getInitialValue());
};
